import { CarFinancialEntity, getCurrentValue } from '../../financialEntities';
import { calculateForecastAmount } from '../../forecasting';
import { dt } from '../../util/dateTime';
import { isNumber } from '../../util/types';
import { makeValueSeriesGenerator } from '../makeGenerator';
import { endOfTickDateStr } from '../ticks';
import { FEValueNode, SnapshotBase, VSGContext } from '../types';
import {
    makeDefaultCurrentValueNodeGenerator,
    makeDefaultPastValueNodeGenerator,
} from './helpers';

type Params = {
    balance?: number;
    expectedReturn?: number;
};

export const makeCarValueSeriesGenerator = (
    entity: CarFinancialEntity,
    snapshots: SnapshotBase[],
    ctx: VSGContext,
    params: Params = {}
) => {
    const currentValue = isNumber(params.balance)
        ? params.balance
        : getCurrentValue(entity) ?? 0;
    const annualGrowthRate = isNumber(params.expectedReturn)
        ? params.expectedReturn
        : entity.info.expectedReturn ?? 0;
    const vnParams = { ...ctx.baseValueNodeParams };

    return makeValueSeriesGenerator<SnapshotBase, FEValueNode>({
        snapshots,
        currentDate: ctx.currentDate,
        generatePastValueNode: makeDefaultPastValueNodeGenerator<SnapshotBase>({
            ...vnParams,
        }),
        generateCurrentValueNode:
            makeDefaultCurrentValueNodeGenerator<SnapshotBase>({
                currentValue,
                ...vnParams,
            }),
        generateFutureValueNode: ({ tick }) => {
            const balance = calculateForecastAmount({
                startAmount: currentValue,
                annualGrowthRate,
                startDate: dt(ctx.currentDate).toDateStr(),
                targetDate: endOfTickDateStr(tick),
            });
            return { ...tick, balance, ...vnParams };
        },
    });
};
